<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('departments')">Departamento</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="department.deleted_at" class="mb-6" @restore="restore">
      This department has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/6" label="Empresa">
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name}}</option>
          </select-input>
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/6" label="Nombre" />
          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-3/6" label="Descripción" />
         
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!department.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Departamento</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    department: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      cities: this.cities,
      form: this.$inertia.form({
        name: this.department.name,
        description: this.department.description,
        organization_id: this.department.organization_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('departments.update', this.department.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this department?')) {
        this.$inertia.delete(this.route('departments.destroy', this.department.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this department?')) {
        this.$inertia.put(this.route('departments.restore', this.department.id))
      }
    },
  },
}
</script>
